import { Input, Output, ViewChild, ElementRef, EventEmitter } from '@angular/core';
import { IChangeCallback } from '../../../_entities';

export abstract class PopoverInput {

	constructor() { }

	public originalValue: any;
	public dirtyValue: any;

	@Input() id: string;

	@Input() placement: string = "bottom";

	@Input() name: string;

	//whether to allow a control to be null / empty
	@Input() allowEmpty: boolean = false;

	@Input('value')
	set setValue(val: any) {
		this.originalValue = val;
		this.dirtyValue = val;

		this.valueChanged();
	}

	valueChanged() : void { }

	get hasChanges() { return this.originalValue != this.dirtyValue; }

	@Input() disabled: boolean = false;

	@Output('changeCallback') changeCallback = new EventEmitter<IChangeCallback<any>>();

	@ViewChild('focus') focusRef: ElementRef;

	onShow(): void {

		if (this.focusRef) {
			setTimeout(() => {
				this.focusRef.nativeElement.focus();
				//this.focusRef.nativeElement.scrollIntoViewIfNeeded();
			});
		}
	}

	onSave(event: any): void {

		console.log("popoverInput::onSave");

		this.changeCallback.emit({
			id: this.id,
			newValue: this.dirtyValue,
			oldValue: this.originalValue,
			resolve: () => {
				//this.originalValue = this.dirtyValue;
				event.resolve();
			}
			,
			reject: (response: string) => {
				event.reject(response);
			}
		});
	}

	onCancel() {
		this.dirtyValue = this.originalValue;
		console.log("popoverInput::onCancel");
	}


}

export interface IDropdownItem {
	value: any;
	text: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/editable-popover/base/popover-input.ts